import Business from './business'
import Pages from 'app/interface/redux/types/pages'

const Default: Pages = {
  business: Business,
}

export default Default
